'use strict';
var moment = require('moment');


module.exports = {

    imagesAllowed: ['.jpg', '.jpeg', '.bmp', '.png'],

    validateNumeric: function validateNumeric(obj) {
        if (!isNaN(parseFloat(obj.value)) && isFinite(obj.value) || obj.value.length === 0) {
            obj.valid = true;
            obj.validationmessage = '';
        } else {
            obj.valid = false;
            obj.validationmessage = 'Input must be numeric';
        }
    },

    validateNumericPositive: function validateNumericPositive(obj) {
        if (/^([1-9][0-9]{0,4}(?:[\.][0-9]*)?|0*\.0*[1-9][0-9]*)(?:[eE][+-][0-9]+)?$/.test(obj.value) || (obj.value.length === 0 && !obj.required)) {
            obj.valid = true;
            obj.validationmessage = '';
        } else {
            obj.valid = false;
            obj.validationmessage = 'Not a valid number';
        }
    },

    validateIntegerDataType: function validateIntegerDataType(obj) {
        if (Number(obj.value) < 2147483647) {
            obj.valid = true;
            obj.validationmessage = '';
        } else {
            obj.valid = false;
            obj.validationmessage = 'Invalid number';
        }
    },

    validatePassword: function validatePassword(passwordObj) {
        var password = passwordObj.value;
        if (!/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[(){}#!@$%^&*\[\]]).{8,24}$/.test(passwordObj.value)) {
            passwordObj.valid = false;
            passwordObj.validationmessage = "Between 8-24 characters, 1 lower case, 1 upper case, 1 digit, 1 special character [](){}#!@$%^&*";
        }
    },

    matchValue: function matchValue(obj, objToMatch) {
        if (obj.value !== objToMatch.value) {
            obj.valid = false;
            obj.validationmessage = objToMatch.name + "s do not match";
        }
    },

    hasNumber: function hasNumber(obj) {

        if (/\d/.test(obj.value)) {
            obj.valid = false;
            obj.validationmessage = 'Name cannot contain numbers';
        } else {
            obj.valid = true;
            obj.validationmessage = '';
        }
    },

    validatePastDate: function validatePastDate(dateObj) {

        var self = this;

        var now = moment();
        var dateVal = moment(dateObj.value);

        if (dateVal.isBefore(now) && dateVal.isAfter(now.clone().subtract(100, 'y'))) {
            dateObj.valid = true;
            dateObj.validationmessage = '';
            dateObj.value = moment(dateObj.value).format('MM/DD/YYYY');
        } else {
            dateObj.valid = false;
            dateObj.validationmessage = 'Invalid date';
        }
    },

    dateInput: function dateInput(e) {

        var val = e.target.value;

        if (val.length < 8 /*&& e.keyCode !== 8*/) {

            if (val.length === 2) {
                if (val[val.length - 1] === '/') {

                    e.target.value = '0' + e.target.value;
                } else {
                    e.target.value += '/';
                }
            }
            if (val.length === 5) {
                if (val[val.length - 1] === '/') {
                    e.target.value = e.target.value.slice(0, 3) + '0' + e.target.value.slice(3);
                } else {
                    e.target.value += '/';
                }
            }
        }
    },

    validateBirthdate: function validateBirthdate(dateObj) {
        // First check for the pattern
        if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateObj.value)) {
            dateObj.valid = false;
            dateObj.validationmessage = "Invalid birthdate";
            return;
        }

        // Parse the date parts to integers
        var parts = dateObj.value.split("/");
        var day = parseInt(parts[1], 10);
        var month = parseInt(parts[0], 10);
        var year = parseInt(parts[2], 10);

        var today = new Date();

        var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

        // Adjust for leap years
        if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0))
            monthLength[1] = 29;

        // Check the range of the day
        //return day > 0 && day <= monthLength[month - 1];

        if (year < (today.getFullYear() - 110) ||   //can't be over 100 years old
            month === 0 ||                          //month cannot be zero
            month > 12 ||                           //month cannot be more than 12 === December
            day < 1 ||                              //day must at least be one
            day > monthLength[month - 1])           //day cannot exceed the month's number of days
        {
            dateObj.valid = false;
            dateObj.validationmessage = "Invalid birthdate";
        }
    },

    validateEmail: function validateEmail(emailObj) {

        emailObj.valid = true;
        emailObj.validationmessage = "";

        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (!re.test(String(emailObj.value).toLowerCase())) {
            emailObj.valid = false;
            emailObj.validationmessage = "Invalid email address";
        } else if (/@myfwc.com\s*$/.test(String(emailObj.value))) {
            emailObj.valid = false;
            emailObj.validationmessage = "FWC Official Email Address is not valid";
        }
    },

    validatePhoneNumber: function validatePhoneNumber(phoneObj) {

        var digitstring = phoneObj.value.replace(/\D/g, "");
        var charstring = phoneObj.value.replace(/\d/g, "");

        if (charstring.length > 0 && charstring.replace(/[\.\+\(\)\-\ ]/g, "").length > 0) {
            //phone number contains disallowed characters
            phoneObj.valid = false;
            phoneObj.validationmessage = "Invalid phone number";
        }
        else if (digitstring.length > 8 && digitstring.length < 16) {
            //phone number valid
            phoneObj.valid = true;
            phoneObj.validationmessage = "";
        }
        else if (digitstring.length > 1 && digitstring.length < 8) {
            //phone number too short
            phoneObj.valid = false;
            phoneObj.validationmessage = "Invalid number, please provide area code";
        }
        else {
            //phone number too long
            phoneObj.valid = false;
            phoneObj.validationmessage = "Invalid number";
        }
    },

    validateCity: function validateCity(cityObj) {

        var self = this;

        //check city
        if (cityObj.allvalues.length > 0) {

            //does entered city match options for chosen state?
            cityObj.valid = self.arrayHasValue(cityObj.allvalues, cityObj.value);

            if (!cityObj.valid) {
                cityObj.validationmessage = "City not in chosen state";
            }
        } else {
            cityObj.valid = false;
        }
    },

    validateZipCode: function validateZipCode(zipcodeObj) {

        var self = this;

        //check zipcode
        if (zipcodeObj.allvalues.length > 0) {

            //does entered zip match options for chosen city?
            zipcodeObj.valid = self.arrayHasValue(zipcodeObj.allvalues, zipcodeObj.value);

            if (!zipcodeObj.valid) {
                zipcodeObj.validationmessage = "Zipcode not in city";
            }
        } else {
            zipcodeObj.valid = false;
        }
    },

    validatePhotoExtension: function validatePhotoExtension(obj, fileName) {

        var self = this;
        obj.valid = true;

        for (var i = 0; i < self.imagesAllowed.length; i++) {

            //is photo extension allowed?
            obj.valid = fileName.toLowerCase().indexOf(self.imagesAllowed[i]) > -1;

            if (!obj.valid) {
                obj.validationmessage =
                    'Invalid file. Allowed extensions (.jpeg, .jpg, .png, .bmp).';
            } else {
                obj.validationmessage = '';
                break;
            }
        }
        
    },

    validateRequired: function validateRequired(obj) {

        var self = this;

        if (self.isNullOrEmpty(obj.value)) {
            obj.valid = false;
            obj.validationmessage = "Required field";
        } else {
            obj.valid = true;
            obj.validationmessage = '';
        }
    },

    validateSpecies: function validateSpecies(speciesObj) {

        var self = this;

        speciesObj.valid = true;
        speciesObj.validationmessage = '';

        if (self.isNullOrEmpty(speciesObj.id) && (self.isNullOrEmpty(speciesObj.name) || self.isNullOrEmpty(speciesObj.name.trim()))) {
            speciesObj.valid = false;
            speciesObj.validationmessage = 'Required field';
        }

        if (speciesObj.id === 'other' && self.isNullOrEmpty(speciesObj.name)) {
            speciesObj.valid = false;
            speciesObj.validationmessage = 'Please specify the unlisted species';
        }
    },

    validateLength: function validateLength(obj) {
        if (obj.value.trim().length <= obj.maxlength && obj.value.trim().length >= obj.minlength) {
            obj.valid = true;
            obj.validationmessage = '';
        } else if (obj.value.trim().length > obj.maxlength) {
            obj.valid = false;
            obj.validationmessage = "Input too long (max " + obj.maxlength.toString() + " chars)";
        } else if (obj.value.trim().length < obj.minlength) {
            obj.valid = false;
            obj.validationmessage = "Input too short (min " + obj.minlength.toString() + " chars)";
        }
    },

    validateArrayLength: function validateLength(ethnicityValue) {
        //var ethnicityObj = ethnicityValue.split(',');
        //check ethnicity
        if (ethnicityValue.value.length > 0) {
            ethnicityValue.valid = true;
        } else {
            ethnicityValue.valid = false;
            ethnicityValue.validationmessage = "Please select any one ethnicity";
        }
    },

    arrayHasValue: function arrayHasValue(array, value) {
        for (var i = 0; i < array.length; i++) {
            if (array[i].toLowerCase() === value.toLowerCase()) {
                return true;
            }
        }
        return false;
    },

    isNullOrEmpty: function isNullOrEmpty(s) {
        return (s == null || s === "");
    },

    validateZeroValue: function validateLength(obj) {
        
        if (obj.value === "")
            return false;
        else
            return true;
    }
}

